//import SVG from 'svg.js';
import eventbus from 'tiny-emitter/instance';
import { getAngle } from '@/core/drawing/utils';

import SelectionBox from './selectionBox';
import { useActions } from '@/store/useStore';

export default class DraggerBox extends SelectionBox {
  dragging = false;
  dragged = false;
  rotating = false;
  coords = Object.create(null);

  constructor(app) {
    super(app);
    this.addControlViews();
    this.addListenersToControls();
  }

  stopPrevent(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  addControlViews() {
    this.line = this.nested.line(0, 20, 0, 0).addClass('selection-box-line');
    this.rotationCircle = this.nested.circle(10).center(0, 0).addClass('selection-box-circle');
    this.selectionBox.add(this.rotationCircle).add(this.line);
  }

  addListenersToControls() {
    this.selectionRect.on('mousedown', this.handleMouseDown, this);
    this.rotationCircle.on('mousedown', this.handleMouseDown, this);

    this.selectionRect.on('dblclick', () => {
      const section = this.app.seatmap.selection.sections[0];
      section.edit();
    });
  }

  removeListenersFromControls() {
    this.selectionRect.off('mousedown', this.handleMouseDown);
    this.rotationCircle.off('mousedown', this.handleMouseDown);
  }

  addMouseListeners() {
    this.app.svg.on('mousemove', this.handleMouseMove, this);
    this.app.svg.on('mouseup', this.handleMouseUp, this);
  }

  removeMouseListeners() {
    this.app.svg.off('mousemove', this.handleMouseMove);
    this.app.svg.off('mouseup', this.handleMouseUp);
  }

  handleMouseDown(e) {
    if (e.detail >= 2) return; // handle multiclick gracefully
    switch (e.target) {
      case this.rotationCircle.node:
        this.rotating = true;
        break;
      case this.selectionRect.node:
        this.dragging = true;
        break;
      default:
        break;
    }
    this.initAction(e);
  }

  handleMouseMove(e) {
    if (this.dragging || this.rotating) {
      this.stopPrevent(e);
      this.calculateDeltaCoords(e);
      if (this.dragging) {
        this.move();
        eventbus.emit('drag:move', this.coords, e);
      } else {
        const { rectCx: x, rectCy: y } = this.coords;
        const { x2, y2 } = this.coords;
        // because we have circle not at (0,0) but at 270 degrees angle,
        // we should recalculate the angle
        this.coords.angle = Math.round(getAngle({ x, y, x2, y2 })) - 270;
        //this.rotate(this.coords.angle, x, y);
        this.rotate();
        eventbus.emit('rotate:move', this.coords.angle, x, y, e);
      }
    }
  }

  handleMouseUp(e) {
    if (this.dragging || this.rotating) {
      this.stopPrevent(e);
      this.calculateDeltaCoords(e);
      this.removeMouseListeners();
      if (this.dragging) {
        this.dragged = !!this.coords.x2;
        eventbus.emit('drag:end', this.coords, this.dragged);
      } else {
        eventbus.emit('rotate:end', this.coords.angle, this.coords.rectCx, this.coords.rectCy);
      }
      this.dragging = false;
      this.rotating = false;
      this.coords = Object.create(null);
    }
  }

  initAction(e) {
    if (this.dragging || this.rotating) {
      this.stopPrevent(e);
      this.addMouseListeners();
      this.updateBBox(e);
      if (this.dragging) {
        eventbus.emit('drag:start', this.coords, e);
      } else {
        eventbus.emit('rotate:start', this.coords, e);
      }
    }
  }

  // called from parent class eventbus
  updateView(bbox) {
    this.line.plot(bbox.cx, bbox.y, bbox.cx, bbox.y - 20);
    this.rotationCircle.center(bbox.cx, bbox.y - 25);
    super.updateView(bbox);
    this.nested.front();
  }

  move() {
    //To-DO - Selection box showing wrong coordinates on move, so hiding selection box for now.
    this.selectionBox.hide();
    /*this.selectionBox.transform({
      x: this.coords.boxX + this.coords.dx,
      y: this.coords.boxY + this.coords.dy,
    });*/
  }

  /*rotate(angle, cx, cy) {
    //const rm = (new SVG.Matrix()).rotate(angle, cx, cy);
    //this.selectionBox.transform(rm.multiply(this.coords.matrix));
  }*/

  rotate() {
    //To-DO - Selection box showing wrong coordinates on rotate, so hiding selection box for now.
    this.selectionBox.hide();
  }

  calculateDeltaCoords(e) {
    const { x, y } = this.app.getTransformedCoords(e);
    this.coords.x2 = x;
    this.coords.y2 = y;
    this.coords.dx = this.app.snap(this.coords.x2 - this.coords.startX);
    this.coords.dy = this.app.snap(this.coords.y2 - this.coords.startY);
  }

  updateBBox(e) {
    const { x, y } = this.app.getTransformedCoords(e);
    const { cx, cy } = this.selectionRect.rbox(this.app.svg.doc());
    const { matrix } = this.selectionBox.transform();
    this.coords.startX = x;
    this.coords.startY = y;
    this.coords.boxX = this.selectionBox.x();
    this.coords.boxY = this.selectionBox.y();
    this.coords.rectCx = cx;
    this.coords.rectCy = cy;
    this.coords.matrix = matrix;
    this.coords.angle = 0;
  }

  destroy() {
    this.removeListenersFromControls();
    super.destroy();
  }
}
